import { derive } from 'store-utils';
import { createAsyncState } from 'async-utils';
import { Nullable } from 'common-types';
import { FilterTypeToFilter } from '../../../common/filters-utils/filters-utils';
import { createStore } from 'store-utils';
import {
  FilterByTypesToolTip,
  FilterIssueType,
  IssueDetails,
  IssuesOrder,
  IssueSortKey,
  SearchInput,
} from '../../common/types/issues-types';
import { Issue } from '../../common/types/issues-types';

export const initialResolvedIssuesState: Partial<ResolvedIssuesStoreState> = {
  issues: [],
  selectedIssue: null,
  totalIssues: 0,
  offset: 0,
  issuesFiltersType: null,
  issuesFiltersTypeSearch: null,
  isModalVisible: false,
  filtersOpen: true,
  order: [IssuesOrder.Desc],
  orderBy: [IssueSortKey.Severity],
  filterIssuesBy: {},
  totalFilteredIssues: 0,
  filtersByTypesToolTip: { category: '', value: '' },
  selectedIssueId: null,
  policyDisableModal: false,
  loadingIssue: false,
  applicationIrrelevantModal: false,
  sliderValuePriority: [0, 100],
  lastDrawerHeight: undefined,
  isFromTopIssues: false,
  isActiveJiraConnection: false,
  isActiveSlackConnection: false,
  showCreateJiraTicketDialog: false,
  showSendSlackMessageDialog: false,
  isQuickFixModalVisible: false,
  isQuickFixPermissionDeniedModalVisible: false,
  isFilesDiffModalVisible: false,
  menuIssueId: null,
  applicationStatistics: null,
  totalResolvedIssues: 0,
  totalActiveIssues: 0,
  commentModal: false,
  isAddingCommentLoading: false,
  issueComment: '',
  loadingJiraTicketsStatus: false,
  searchValues: [],
  searchValue: '',
};

const baseStore = createStore<ResolvedIssuesStoreState>(
  {
    ...JSON.parse(JSON.stringify(initialResolvedIssuesState)),
    loading: createAsyncState(),
    loadingFilters: createAsyncState(),
  },
  'Resolved Issues Store',
);

const ResolvedIssuesStore = derive(
  {
    numberOfFilters: get => {
      const { filterIssuesBy } = get(baseStore);
      return (
        Object.keys(filterIssuesBy).reduce(
          (acc, key) =>
            key === FilterTypeToFilter.BusinessPriority
              ? acc + 1
              : acc + filterIssuesBy[key].length,
          0,
        ) || 0
      );
    },
  },
  { proxy: baseStore },
);

export interface ResolvedIssuesStoreState {
  issues: Issue[];
  selectedIssue: Nullable<IssueDetails>;
  selectedIssueId: Nullable<string>;
  totalIssues: number;
  offset: number;
  loading: ReturnType<typeof createAsyncState>;
  loadingFilters: ReturnType<typeof createAsyncState>;
  loadingJiraTicketsStatus: boolean;
  issuesFiltersType: Nullable<FilterIssueType>;
  issuesFiltersTypeSearch: Nullable<FilterIssueType>;
  isModalVisible: boolean;
  filtersOpen: boolean;
  order: IssuesOrder[];
  orderBy: IssueSortKey[];
  filterIssuesBy: {};
  totalFilteredIssues: number;
  filtersByTypesToolTip: FilterByTypesToolTip;
  policyDisableModal: boolean;
  loadingIssue: boolean;
  applicationIrrelevantModal: boolean;
  sliderValuePriority: number[];
  lastDrawerHeight?: number;
  isFromTopIssues: boolean;
  isActiveJiraConnection: boolean;
  isActiveSlackConnection: boolean;
  showCreateJiraTicketDialog: boolean;
  showSendSlackMessageDialog: boolean;
  isQuickFixModalVisible: boolean;
  isQuickFixPermissionDeniedModalVisible: boolean;
  isFilesDiffModalVisible: boolean;
  menuIssueId: Nullable<Issue['id']>;
  applicationStatistics: Nullable<FilterIssueType>;
  totalResolvedIssues: number;
  totalActiveIssues: number;
  commentModal: boolean;
  isAddingCommentLoading: boolean;
  issueComment: string;
  searchValues: SearchInput[];
  searchValue: string;
}

export default ResolvedIssuesStore;
